import Layout from "../../../components/Layout/Layout"
import { useNavigate, useParams } from "react-router-dom"
import OrderService from "../../../components/OrderService/OrderService"
import ProductLayoutLoader from "../../../components/LayoutLoaders/ProductLayoutLoader"

export default function OrderServicePage() {
  const { category_id, service_id } = useParams()
  const navigate = useNavigate()

  if (!category_id || !service_id) navigate("/")

  return (
    <Layout mainLoader={<ProductLayoutLoader />} isHeaderMobHidden>
      {service_id && category_id && <OrderService id={service_id} categoryId={category_id} />}
    </Layout>
  )
}
